module.exports = __webpack_public_path__ + "static/media/Cloudflare.bfd2cbf7.svg";